<template>
	<div id="activity" v-html="yyhd">
		<img src="../../assets/1-200H1150515962.jpg">
	</div>
</template>
<style lang="scss" scoped>
	#activity {
		img {
			width: 100%;
			display: block;
		}
	}
</style>

<script>
	import {
		Toast
	} from 'mint-ui';
	export default {
		name: "Activity",
		data() {
			return {
				yyhd:'../../assets/1-200H1150515962.jpg'
			};
		},
		created() {
		this.getYyhdData();
		},
		methods: {
			getYyhdData() {
				let params = {
					params: {
			
					}
				};
				this.$http.get(this.$api.GHyyhd, params).then(res => {
					// console.log('获取医生成功');
					console.log(res);
					if (res.data.code == 0) {
						this.yyhd = res.data.data[0].yyhd;
					} else {
						Toast({
							message: res.data.msg,
							position: 'center',
							duration: 2000
						});
					}
				}).catch(error => {
					// console.log('获取医生失败');
					// console.log(error);
					Toast({
						message: error.data.msg || error.data.message,
						position: 'center',
					});
				});
			}
			
		}
	};
</script>
